import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-everis-listado',
  templateUrl: './everis-listado.component.html',
  styleUrls: ['./everis-listado.component.scss']
})
export class EverisListadoComponent implements OnInit {

  customers: any[] = [];
  estados: any[] = [];
  estado: any = [];
  new_estado: string = null;

  // Columns
  dni = true;
  email = true;
  tlf = true;
  cuenta = true;
  historico = false;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(public rest: RestService) { }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_',
        info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      },
      responsive: true,
      scrollX: true,
    };
    this.getListadoInit();
    this.GetEstadosCientes();
  }

  getListado() {
    const destroy = new Promise(
      (resolve, reject) => {
        this.dtTrigger.unsubscribe();
        resolve();
      }
    );

    this.rest.getListadoEveris().subscribe((data) => {
      console.log(data);

      destroy.then((then) => {
        this.customers = data['data'];
        this.dtTrigger.next();
      });
    });
  }

  setTipoAbono(objeto, value) {

    const opcion = confirm('¿Establecer ' + value + ' para este cliente ?');
    if (opcion === true) {
      this.rest.postChangue_Abono(objeto.id, value).subscribe( (data) => {
        this.getListado();
      });
    }

  }

  verify($event) {
    this.estado = $event['estado'];
  }

  hideColumn() { this.historico = !this.historico; }

  getListadoInit() {
    this.rest.getListadoEveris().subscribe((data) => {
      this.customers = data['data'];
      this.dtTrigger.next();
    });
  }

  setEvent($event) {
    this.new_estado = $event.target.value;
  }

  ChangueStateCustomer(customer) {

    if (this.estado != null) {
      this.rest.postChangeStateEveris(customer.id, this.new_estado, this.estado).subscribe((data) => {
        this.new_estado = '';
        this.estado = '';
        this.getListado();
      });
    }

  }

  GetEstadosCientes() {
    this.rest.postGetEstados_Everis().subscribe((data) => {
      this.estados = data['data'];
    });
  }


  deleteHistorico(his) {
    const opcion = confirm('¿Estas muy seguro que quieres borrar esto?');
    if (opcion === true) {
      this.rest.deleteHistorico(his.id)
      .subscribe( (data) => {
        this.getListado();
      });
    }

  }


}
